export const extractStacktrace = (ex: Error) => {
  return ex.stack?.replace(/^.*(?=\n)/, '') || '';
};

export const logIfCallPath = (stacktrace: string, text: string, params: string) => {
  if (CONFIG.debug) {
    const callPath = stacktrace.match(/at \w+/g);
    if (callPath) {
      console.info(text, params, callPath.slice(1, callPath.findIndex(v => /at [A-Z]/.test(v)) + 1).join(' '));
    }
  }
};
